export default "__VITE_ASSET__CuHpOQ$4__"